// extracted by mini-css-extract-plugin
module.exports = {"SubscribeNewProduct":"SubscribeNewProduct_SubscribeNewProduct__ydnWT"};